export const Footer = () => (
  <footer className="bg-background border-t border-border py-12" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div>
        <div className="font-heading font-extrabold text-2xl tracking-tighter text-primary">
          Heal<span className="text-secondary">seeal</span>
        </div>
        <p className="font-serifaccent italic text-text-muted mt-1">Seal. Protect. Heal.</p>
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-2">
        {["Formulation", "Bioactives", "Certification", "How It Works", "Contact"].map((l) => (
          <a
            key={l}
            href={`#${l.toLowerCase().replace(/\s/g, "-")}`}
            className="text-sm text-text-muted hover:text-primary transition-colors duration-200"
          >
            {l}
          </a>
        ))}
      </div>
      <p className="font-monotech text-xs text-text-muted">© 2026 Healseeal Labs</p>
    </div>
  </footer>
);
